import React from 'react';
import PropTypes from 'prop-types';

import { ITEM_TYPES } from '../../constants';
import InfiniteRowsScene from '../InfiniteRowsScene';
import api from '../../utils/api';

class NewsList extends React.Component {
  static propTypes = {
    newsList: PropTypes.object,
  };

  render() {
    const { ...rest } = this.props;

    return <InfiniteRowsScene loadMoreFunc={api.news} page={ITEM_TYPES.news} {...rest} />;
  }
}

export default NewsList;



// WEBPACK FOOTER //
// ./src/scenes/NewsList/index.js